export default __webpack_public_path__ + "static/media/bulk-microbulk-banner.fae6201b.jpg";